export default __webpack_public_path__ + "static/media/swiss-flower-dangler.a44aac94.jpg";